// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/js/chunks/" + chunkId + ".d262d16b-fce8-4971-8c04-f4e8e8ccb513.js";
};